export const parseHtmlString = (htmlString: string): HTMLDocument => {
	const parser = new DOMParser();
	return parser.parseFromString(htmlString, 'text/html');
};

export const serializeHtmlToString = (htmlDocument: HTMLDocument): string => (
	htmlDocument.body.innerHTML
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/html-parse-serialize.ts